module.exports = __webpack_public_path__ + "img/5-3.a4c1f01f.jpg";